import { ValidationErrors } from 'final-form';

import { validateCronExpressionOfTask } from './cronExpression';
import { MSTeamsConfigurationType } from '../../scene/integrations/types';

export const validateMSTeamsForm = (values: MSTeamsConfigurationType): ValidationErrors => ({
  tasks: [
    {
      // user sync
      cronExpression: validateCronExpressionOfTask(values.tasks[0]),
    },
  ],
  streams: [],
});
